import { getCache } from '@/utils/cache'
import { RebrandedTheme, RebrandedBrandColors } from '@conexasaude/conexa-hero'
import { cnxTokens } from '@conexasaude/hero-tokens'
import merge from 'deepmerge'

export const generateRebrandedTheme = (
  colors: RebrandedBrandColors,
): RebrandedTheme => {
  const theme: RebrandedTheme = merge(cnxTokens, {
    colors: {
      brand: {
        primary: colors.primary,
        secondary: colors.secondary,
        tertiary: colors.tertiary,
      },
    },
  } as Partial<RebrandedTheme>)

  return theme
}

export const getInitialRebrandedTheme = (): RebrandedTheme => {
  const colors = getCache<RebrandedBrandColors>('rebranded-colors')

  if (colors) {
    return generateRebrandedTheme({
      primary: colors.primary,
      secondary: colors.secondary,
      tertiary: colors.tertiary,
    })
  }

  return generateRebrandedTheme(cnxTokens.colors.brand)
}
